import React, { useRef } from "react";
import { PageInfo } from "../../../pages/admin/dashboard/promotionCenter";
import { useLocation, useNavigate, useParams } from "react-router-dom";
export interface Props {pageInfo : PageInfo, column : any}
export const ListHeader:React.FC<Props> = ({pageInfo, column}) => {
    const {contentsType} = useParams()
    const searchRef = useRef<any>(null)
    const location = useLocation()
    const keyword : any = new URLSearchParams(location.search).get('keyword') || ''
    const navigate = useNavigate()
    const handleSearch = () => {
        navigate(`${location.pathname}?page=1&keyword=${searchRef.current.value}&column=${column}&order=desc`)
    }
    const handleEnter = (e:any) => {if(e.key==='Enter'){handleSearch()}}
    return(
        <>
        <div className="flexWrap">
            <div className="flexBox">
                <h4>
                    {pageInfo.title}
                    <span className="content_count">{pageInfo.totalCount}</span>
                </h4>
                {contentsType === 'inquiry' ? '' : 
                <button className="addBtn" onClick={()=>navigate(`${location.pathname}/regist`)}>
                    <i className="fa-solid fa-plus"></i>
                    <span>Add New</span>
                </button>
                }
            </div>
            <div className="search_box">
                <input type="text" ref={searchRef} onKeyDown={handleEnter} placeholder="Search ..."/>
                <button type="button" className="ic-button" onClick={handleSearch}>
                    <img src="/assets/images/searchBox.png" alt="검색아이콘"/>
                </button>
            </div>
        </div>
        </>
    )
}